import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import {
  getResponseLevels,
  getStandards,
  getMaintenanceTrigger,
  MaintenanceTrigger,
  getStandardDetails,
  setClonedUrl,
  resetState
} from './MaintenanceTriggerForm.slice';
import Busy from '../../Shared/Busy';
import MaintenanceTriggerForm from './MaintenanceTriggerForm';
import { AnnotationStandardDetails } from '../../AnnotationManager/AnnotationStandardForm/AnnotationStandardForm.slice';

type Props = {
  maintenanceTrigger: MaintenanceTrigger | null;
  standard: AnnotationStandardDetails | null;
  clonedUrl: string;
  onGetResponseLevels: () => void;
  onGetStandards: () => void;
  onGetMaintenanceTrigger: (id: string) => void;
  onGetStandard: (id: string) => void;
  setClonedUrl: (url: string) => void;
  onResetState: () => void;
};

export const MaintenanceTriggerPage: FC<RouteComponentProps<{ id: string }> & Props> = ({
  match,
  history,
  maintenanceTrigger,
  standard,
  clonedUrl,
  onGetResponseLevels,
  onGetStandards,
  onGetMaintenanceTrigger,
  onGetStandard,
  setClonedUrl,
  onResetState
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const { id } = match.params;

    if (id) {
      onGetMaintenanceTrigger(id);
      return;
    }

    setIsLoading(false);
  }, [match.params, onGetMaintenanceTrigger]);

  useEffect(() => {
    onGetStandards();
    onGetResponseLevels();
    return () => {
      onResetState();
    };
  }, [onGetResponseLevels, onGetStandards, onResetState]);

  useEffect(() => {
    if (maintenanceTrigger) {
      onGetStandard(maintenanceTrigger.annotationStandardId);
    }
  }, [maintenanceTrigger, onGetStandard]);

  useEffect(() => {
    if (standard) {
      setIsLoading(false);
    }
  }, [maintenanceTrigger, standard]);

  if (clonedUrl.length) {
    setClonedUrl('');
    history.push(clonedUrl);
    window.history.go();
    onResetState();
    return <Busy />;
  }

  if (isLoading) {
    return <Busy />;
  }

  return <MaintenanceTriggerForm />;
};

const mapStateToProps = (state: RootState) => ({
  maintenanceTrigger: state.maintenanceTriggerForm.maintenanceTrigger,
  standard: state.maintenanceTriggerForm.standard,
  clonedUrl: state.maintenanceTriggerForm.clonedUrl
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onGetResponseLevels: () => dispatch(getResponseLevels()),
  onGetStandards: () => dispatch(getStandards()),
  onGetMaintenanceTrigger: (id: string) => dispatch(getMaintenanceTrigger(id)),
  onGetStandard: (id: string) => dispatch(getStandardDetails(id)),
  setClonedUrl: (url: string) => dispatch(setClonedUrl(url)),
  onResetState: () => dispatch(resetState())
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceTriggerPage);
